<template>
	<div>
		<FormulateInput
			class="mb-3 small"
			name="b2bAlumniInput"
			type="checkbox"
			data-action="b2bAlumniInput"
		>
			<template #label="{ id }">
				<label :for="id" class="ml-2">
					{{ $t('b2bAlumniInput') }}
				</label>
			</template>
		</FormulateInput>
	</div>
</template>

<script>
import agreementsMixin from '~/mixins/agreementsMixin';

export default {
	name: 'b2bAlumniInput',
	mixins: [
		agreementsMixin,
	],
	props: {
		additionalClasses: {
			type: String,
			default: '',
		},
	},
};
</script>

<style scoped>

</style>
